import styled from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';

export const InputWithRubleSymbol = styled(InputSimple)`
    margin: 0;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 16px;
        width: 24px;
        height: 24px;
        background-image: url('/static/images/payments-abn/ruble.svg');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        transform: translateY(-50%);
    }

    & > p {
        position: absolute;
        left: 0;
        top: 100%;
    }
`;
